import { useBooleanFlagValue } from '@openfeature/react-sdk';

// Production OFREP smoke test: changes only the default-session-tab helper text.
// Provision only in OFREP; Flagsmith takes precedence for shared keys.
export const OFREP_DUMMY_FLAG_KEY = 'release-ofrep-dummy-flag';

export const useIsOfrepDummyFlagEnabled = (): boolean =>
  useBooleanFlagValue(OFREP_DUMMY_FLAG_KEY, false);
